import { defineComponent } from 'vue-demi';
import { s as script$1 } from './OrIcon-d8ea7901.js';
import './OrButton-78a118d7.js';
import { s as script$2 } from './OrIconButton-ad0cbc8d.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createVNode, Fragment, createTextVNode, toDisplayString, createCommentVNode, createBlock } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var OR_NOTIFICATION_TYPE;
(function (OR_NOTIFICATION_TYPE) {
  OR_NOTIFICATION_TYPE["INFO"] = "info";
  OR_NOTIFICATION_TYPE["ERROR"] = "error";
  OR_NOTIFICATION_TYPE["WARNING"] = "warning";
  OR_NOTIFICATION_TYPE["SUCCESS"] = "success";
})(OR_NOTIFICATION_TYPE || (OR_NOTIFICATION_TYPE = {}));
var OR_NOTIFICATION_SIZE;
(function (OR_NOTIFICATION_SIZE) {
  OR_NOTIFICATION_SIZE["DEFAULT"] = "default";
  OR_NOTIFICATION_SIZE["INLINE"] = "inline";
})(OR_NOTIFICATION_SIZE || (OR_NOTIFICATION_SIZE = {}));

/** HTML links are styled by default to match notification type */
var script = defineComponent({
  name: 'OrNotification',
  components: {
    OrIcon: script$1,
    OrIconButton: script$2
  },
  props: {
    /** A simple text content can be provided as a prop */
    content: {
      type: String,
      default: ''
    },
    /** Icon can be overridden with prop or slot regardless of notification type */
    icon: {
      type: String,
      default: ''
    },
    /** Type can be a blank value, for black and white notification */
    type: {
      type: String,
      default: OR_NOTIFICATION_TYPE.INFO
    },
    size: {
      type: String,
      default: OR_NOTIFICATION_SIZE.DEFAULT
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  computed: {
    states() {
      /* This type has no styles but is present on the element for user customization */
      const BLANK_TYPE = 'blank';
      return [`is-type-${this.type || BLANK_TYPE}`, `is-size-${this.size}`];
    },
    iconByType() {
      const DEFAULT_ICON = 'info';
      const TYPE_TO_ICON_MAP = {
        [OR_NOTIFICATION_TYPE.INFO]: 'info',
        [OR_NOTIFICATION_TYPE.ERROR]: 'error',
        [OR_NOTIFICATION_TYPE.WARNING]: 'warning',
        [OR_NOTIFICATION_TYPE.SUCCESS]: 'check_circle'
      };
      return this.icon || TYPE_TO_ICON_MAP[this.type] || DEFAULT_ICON;
    },
    iconColorByType() {
      const DEFAULT_COLOR = 'black';
      const COLOR_TO_ICON_MAP = {
        [OR_NOTIFICATION_TYPE.INFO]: 'primary',
        [OR_NOTIFICATION_TYPE.ERROR]: 'error',
        [OR_NOTIFICATION_TYPE.WARNING]: 'warning',
        [OR_NOTIFICATION_TYPE.SUCCESS]: 'success'
      };
      return COLOR_TO_ICON_MAP[this.type] || DEFAULT_COLOR;
    }
  }
});

const _hoisted_1 = {
  class: "or-notification--icon"
};
const _hoisted_2 = {
  class: "or-notification--content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  const _component_or_icon_button = resolveComponent("or-icon-button");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-notification", _ctx.states])
  }, [createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "icon", {}, () => [createVNode(_component_or_icon, {
    icon: _ctx.iconByType,
    color: _ctx.iconColorByType
  }, null, 8 /* PROPS */, ["icon", "color"])])]), createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default"), !_ctx.$slots.default ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createTextVNode(toDisplayString(_ctx.content), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)]), _ctx.canDelete ? (openBlock(), createBlock(_component_or_icon_button, {
    key: 0,
    icon: "close",
    "icon-color": "neutral-6",
    class: "or-notification--close",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close'))
  })) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-2a8b1558 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-2a8b1558 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-notification[data-v-2a8b1558] {\n  /** TODO: Override when mobile design is ready to guarantee alignment of icons with first text row */\n  --alignment-height: var(--lh-1);\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  padding: var(--s-4);\n  background-color: var(--c-white);\n  border-radius: 0.25rem;\n  box-shadow: 0 0.0625rem 0.25rem 0.0625rem rgba(0, 0, 0, 0.08);\n  transition-timing-function: var(--t-func);\n  transition-duration: var(--t-duration);\n  transition-property: background-color;\n}\n.or-notification.is-size-default[data-v-2a8b1558] {\n  max-width: 48rem;\n}\n.or-notification.is-size-inline[data-v-2a8b1558] {\n  max-width: 27.875rem;\n}\n.or-notification a[data-v-2a8b1558] {\n  font-weight: var(--fw-2);\n  color: var(--c-black);\n}\n.or-notification--icon[data-v-2a8b1558] {\n  display: flex;\n  align-items: center;\n  min-height: var(--alignment-height);\n  margin-right: var(--s-4);\n}\n.or-notification--icon[data-v-2a8b1558] .or-icon {\n  font-size: 1rem;\n}\n.or-notification--content[data-v-2a8b1558] {\n  flex: 1 1 100%;\n  word-break: break-word;\n}\n.or-notification--close[data-v-2a8b1558] {\n  display: flex;\n  height: var(--alignment-height);\n  margin-left: 1rem;\n}\n.or-notification--close[data-v-2a8b1558] .or-icon {\n  font-size: 1rem !important;\n}\n.or-notification.is-type-info[data-v-2a8b1558] {\n  background-color: var(--c-primary-lighten-45);\n}\n.or-notification.is-type-info a[data-v-2a8b1558] {\n  color: var(--c-primary);\n}\n.or-notification.is-type-error[data-v-2a8b1558] {\n  background-color: var(--c-error-lighten-45);\n}\n.or-notification.is-type-error a[data-v-2a8b1558] {\n  color: var(--c-error);\n}\n.or-notification.is-type-warning[data-v-2a8b1558] {\n  background-color: var(--c-warning-lighten-45);\n}\n.or-notification.is-type-warning a[data-v-2a8b1558] {\n  color: var(--c-warning);\n}\n.or-notification.is-type-success[data-v-2a8b1558] {\n  background-color: var(--c-success-lighten-45);\n}\n.or-notification.is-type-success a[data-v-2a8b1558] {\n  color: var(--c-success);\n}\n[data-theme=dark] .or-notification .or-icon[data-v-2a8b1558] {\n  color: var(--c-neutral-1);\n}\n[data-theme=dark] .or-notification.is-type-info[data-v-2a8b1558] {\n  background-color: var(--c-primary-darken-45);\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-info a[data-v-2a8b1558] {\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-error[data-v-2a8b1558] {\n  background-color: var(--c-error-darken-45);\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-error a[data-v-2a8b1558] {\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-warning[data-v-2a8b1558] {\n  background-color: var(--c-warning-darken-45);\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-warning a[data-v-2a8b1558] {\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-success[data-v-2a8b1558] {\n  background-color: var(--c-success-darken-45);\n  color: var(--c-neutral-6);\n}\n[data-theme=dark] .or-notification.is-type-success a[data-v-2a8b1558] {\n  color: var(--c-neutral-6);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-2a8b1558";
script.__file = "src/components/or-notification/OrNotification.vue";

export { OR_NOTIFICATION_TYPE as O, OR_NOTIFICATION_SIZE as a, script as s };
